import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';
import global from '../../../common/utility/global';
import { RUC } from '../../../common/types/tipoDocumentoType';
import { HABIDO } from '../../../common/types/condicionSunatType';
import { ACTIVO } from '../../../common/types/estadoContribuyenteType';

import transporteService from '../../../service/logistica/transporteService';
import condicionSunatService from '../../../service/administracion/condicionSunatService';
import estadoContribuyenteService from '../../../service/administracion/estadoContribuyenteService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import ubigeoService from '../../../service/integracion/ubigeoService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            filter: { nombreEntidad: '', estado: '', ...FILTER },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoDocumento: RUC.ID,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            idCondicionSunat: HABIDO,
            idEstadoContribuyente: ACTIVO,
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            mtc:'',
            /******************/
            searchLoading: false,
            flagRuc: true,
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            departamentos: [],
            provincias: [],
            distritos: []
        }
    };

    handleClearFilters = () => {
        var filter = { nombreEntidad: '', estado: '', ...FILTER };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }

    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await transporteService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Transporte.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await transporteService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Transporte.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await transporteService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await transporteService.eliminar(values);
            else
                response = await transporteService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tiposDocumento = this.state.tiposDocumento;
        formValues.departamentos = this.state.departamentos;
        formValues.condicionesSunat = this.state.condicionesSunat;
        formValues.estadosContribuyente = this.state.estadosContribuyente;
        this.setState({ visible: true, formValues });
    };

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });

        if (response.status === 200) {
            const provincias = await ubigeoService.provincias(response.data.idDepartamento);
            const distritos = await ubigeoService.distritos(response.data.idProvincia);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false,
                    provincias,
                    distritos
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno,
                    idCondicionSunat: { key: response.data.idCondicionSunat },
                    idEstadoContribuyente: { key: response.data.idEstadoContribuyente },
                    idDepartamento: { key: response.data.idDepartamento },
                    idProvincia: { key: response.data.idProvincia },
                    idUbigeo: { key: response.data.idUbigeo },
                    direccion: response.data.direccion,
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }
    };

    handleEdit = async (values) => {
        const response = await transporteService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.tiposDocumento = this.state.tiposDocumento;
            response.condicionesSunat = this.state.condicionesSunat;
            response.estadosContribuyente = this.state.estadosContribuyente;
            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            response.flagRuc = response.idTipoDocumento === RUC.ID ? true : false;
            this.setState({ visible: true, formValues: response });
        }
    };

    handleChangeForm = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritos: distritos ? distritos : []
                }
            });
        }

        if (property === "clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: [],
                    distritos: []
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await transporteService.registrar(values);
            else
                response = await transporteService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    async componentDidMount() {
        this._initPagination(this.state.filter, transporteService.paginacion);

        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        const departamentos = await ubigeoService.departamentos();
        const condicionesSunat = await condicionSunatService.listar();
        const estadosContribuyente = await estadoContribuyenteService.listar();

        this.setState({
            loadingSource: false,
            tiposDocumento: tiposDocumento ? tiposDocumento : [],
            departamentos: departamentos ? departamentos : [],
            condicionesSunat: condicionesSunat ? condicionesSunat : [],
            estadosContribuyente: estadosContribuyente ? estadosContribuyente : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Transporte"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        )
    }
}